import { Button, Text, XStack } from 'tamagui'
import Thumb from '../icons/Thumb'
import { mesaColorNames } from '@/src/common/theme'
import { SimpleUpDownRatingTitle, SurveysE2E } from '../e2e'

export type SimpleUpDownRatingValue = 1 | -1 | 0

export const SimpleUpDownRating = ({
  title,
  rating,
  onRatingChange,
  testIDTitle,
}: {
  title: string
  rating: SimpleUpDownRatingValue
  onRatingChange: (rating: SimpleUpDownRatingValue) => void
  testIDTitle: SimpleUpDownRatingTitle
}) => (
  <XStack gap="$4" justify="center" items="center">
    <Text grow={1}>{title}</Text>
    <Button
      circular
      size="$3"
      variant="outlined"
      borderColor={
        rating === 1 ? mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] : undefined
      }
      icon={
        <Thumb
          width={16}
          height={16}
          fill={rating === 1 ? mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] : undefined}
        />
      }
      onPress={() => onRatingChange(1)}
      testID={SurveysE2E.Ids.Press.SimpleUpDownRating(testIDTitle, 1)}
    />
    <Button
      circular
      size="$3"
      variant="outlined"
      borderColor={rating === -1 ? mesaColorNames['Mesa Third #E78A43'] : undefined}
      icon={
        <Thumb
          width={16}
          height={16}
          fill={rating === -1 ? mesaColorNames['Mesa Third #E78A43'] : undefined}
          style={{ transform: [{ rotate: '180deg' }, { scaleX: -1 }] }}
        />
      }
      onPress={() => onRatingChange(-1)}
      testID={SurveysE2E.Ids.Press.SimpleUpDownRating(testIDTitle, -1)}
    />
  </XStack>
)
